import React, { useState, useEffect } from 'react';
import './style.css';
import { useProgress } from '@react-three/drei';
//poopoo
const frames = [
  `
                                                                           
                                    &                                      
                              &&&&&&&&&&&&                                 
                        &&&&&&&&&&&&&&&&&&&&&&&&                           
                  &&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&                      
            &%%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%                 
      %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%            
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&      
((((((%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
(((((((((((%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((////%%%%%%%%%%%%%%%%%%%%%%%%%%#%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((/////////%%%%%%%%%%%%%%%######%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((////////////%%%%###########%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((/(////////////###########%%%%%%%%%%%%%%%%%%%%%%%%%     
(((((((((((((((((((((/////////////##########%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((((((//////////########%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
(((((((((((((((((((((((///////////#######%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
(((((((((((((((((((((((((/////////#####%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((((((((/(//////####%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((((((((((/(////###%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
(((((((((((((((((((((((((((((/////#%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
(((((((((((((((((((((((((((((((///#%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((((((((((((((//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
((((((((((((((((((((((((((((((((((%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
 #((((((((((((((((((((((((((((((((%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
       (((((((((((((((((((((((((((%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          
            ((((((((((((((((((((((%%%%%%%%%%%%%%%%%%%%%%%%%                
                 (((((((((((((((((%%%%%%%%%%%%%%%%%%%                      
                       (((((((((((%%%%%%%%%%%%%                            
                            ((((((%%%%%%%                                  
                                 (%                                        

`,
  `
                                                                           
                                                                           
                                       &&&&&&&&&&&                         
                          &&&&&&&&&&&&&&&&&&&&&&&&&&                       
             &&&&&&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&&&                    
   &%%%%%%%%%%%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%                  
   ##%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%               
   #####%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%             
   #######%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%           
   ##########%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%        
   ############%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#######       
   ###############%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#####################       
   #################%%%%%%%%%%%%%%##################################       
   #####################(###########################################       
   #################################################################       
   #################################################################       
   #################################################################       
   #################################################################       
   #################################################################       
   #################################################################       
   %################################################################       
   %#############################################################%%#       
   %%#########################################################%%%##%       
    %%######################################################%%%##%%%       
      ####################################################%###%%%%%%       
        ##############################################%%%##%%%%%%%%%       
           ########################################%%###%%%%%%%%%%%%       
             ###################################%%###%%%%%%%%%%%%%%%       
                ############################%%###%%%%%%%%%                 
                  ######################%%%#%                              
                    ############                                           
                                                                           

`,
  `
                                                                           
                                                                           
                                                                           
         &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&                
         &&&&&&&&&&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&&&&&&&                
         &%%%%%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%%                
         &%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%               
         &%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%               
         &&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%               
         &&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%              
         &&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%              
         &&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%              
         &&&((((((((((((((((((((((((((((((((((((((((((((((#(##             
         &&&((((((((((((((((((((((((((((((((((((((####(#######             
         &&&(((((((((((((((((((((((###(#(((###################             
         &&&#########(########################################             
         &&&##################################################             
         &&&##################################################             
         &&&##################################################             
         &&&##################################################             
         &&&##################################################             
         &&&##################################################             
         &&&##################################################             
          &&##################################################             
          &&##################################################             
          &&##################################################             
           &##################################################             
           &##################################################             
           &##################################################             
            ##################################################             
                                                                           
                                                                           

`,
  `
                                                                           
                                                                           
                  &&&&&&&&                                                 
                &&&&&&&&&&&&&&&&&&&&&&&&&&&&%                              
               &&&&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&&&&&&&&&&&            
             %%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%%%%%%%%%         
           %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%         
          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%         
        %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%         
      %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%         
    ,%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%         
    #################%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#%%%%%%%%%%         
    #############################(((((((%%%%%%%%%%%%%###%%%%%%%%%%         
    ###################################(((((((((((((###%%%%%%%%%%%         
    ########################################((((((((###%%%%%%%%%%%         
    ############################################((((###%%%%%%%%%%%         
    ##################################################%%%%%%%%%%%%         
    ##################################################%%%%%%%%%%%%         
    #################################################%%%%%%%%%%%%%         
    #################################################%%%%%%%%%%%%%         
    ################################################%%%%%%%%%%%%%%         
    ################################################%%%%%%%%%%%%%%         
    ################################################%%%%%%%%%%%%%%         
    ################################################%%%%%%%%%%%%%          
    ################################################%%%%%%%%%%%            
    ################################################%%%%%%%%%              
    %#%#############################################%%%%%%%                
    %######%########################################%%%%%%                 
      #%%#%#########################################%%%%                   
                         ###########################%%                     
                                           %########%                      
                                                                           

`,
  `
                                                                           
                              &                                            
                          &&&&&&&&&&&&                                     
                      &&&&&&&&&&&&&&&&&&&&&&&&                             
                 &&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&                      
             %%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%%%%              
         %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%       
     %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%(((     
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%(((((((     
%%%%%%##%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%((((((((((((     
%%%%%%%%%######%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%((((((((((((((((     
%%%%%%%%%%%############%%%%%%%%%%%%%%%%%%%%%%%%%%%((((((((((((((((((((     
%%%%%%%%%%%%%#################%%%%%%%%%%%%%%%%((((((((((((((((((((((((     
%%%%%%%%%%%%%%########################%%%%/(((((((((((((((((((((((((((     
%%%%%%%%%%%%%%%#########################/(/((((((((((((((((((((((((((#     
%%%%%%%%%%%%%%%%%#######################((((((((((((((((((((((((((((##     
%%%%%%%%%%%%%%%%%%%#####################/((((((((((((((((((((((((((###     
%%%%%%%%%%%%%%%%%%%%%###################(((((((((((((((((((((((((((###     
%%%%%%%%%%%%%%%%%%%%%%##################(((((((((((((((((((((((((#####     
%%%%%%%%%%%%%%%%%%%%%%%%################(((((((((((((((((((((((((#####     
%%%%%%%%%%%%%%%%%%%%%%%%%%##############(((((((((((((((((((((((#######     
%%%%%%%%%%%%%%%%%%%%%%%%%%%%############(((((((((((((((((((((((#######     
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%##########(((((((((((((((((((((#########     
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%########(((((((((((((((((((((#########     
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#####(((((((((((((((((((###########     
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%####((((((((((((((((((########         
  %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#(((((((((((((((((#####             
         %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%((((((((((((((((#(                 
                 %%%%%%%%%%%%%%%%%%%%%%%(((((((((((((                      
                        %%%%%%%%%%%%%%%%(((((((((                          
                                %%%%%%%%(((((                              
                                       %(                                  
`,
  `
                                                                           
                                                                           
                                  &&&&&&&&&&&&                             
                         &&&&&&&&&&&&&&&&&&&&&&&&&                         
                 &&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&.                     
        %%%%%%%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%                  
 &%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%              
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%       
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#/////     
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%//////////////     
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%///////////////////////     
 %%%%%%%%%%%%%%%%%%%%%%#%%%%%%%%%%%%%%%///////////////////////////////     
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%////////////////////////////////////////     
 %%%%%%%%%%%%%%%%%%%%%%%%%%%//////////////////////////////////////////     
 &&%%%%%%%%%%%%%%%%%%%%%%%%%//////////////////////////////////////////     
 &&%%%%%%%%%%%%%%%%%%%%%%%%%///////////////////////////////////////(//     
 &&&%%%%%%%%%%%%%%%%%%%%%%%%//////////////////////////////////////(/((     
 &&&&%%%%%%%%%%%%%%%%%%%%%%%////////////////////////////////////(/((((     
 &&&&&%%%%%%%%%%%%%%%%%%%%%%//////////////////////////////////(/((((((     
 &&&&&&%%%%%%%%%%%%%%%%%%%%%//////////////////////////////////((((((((     
 &&&&&&%%%%%%%%%%%%%%%%%%%%%//////////////////////////////((/(((((((((     
 &&&&&&&%%%%%%%%%%%%%%%%%%%%////////////////////////////(//(((((((((((     
 &&&&&&&&%%%%%%%%%%%%%%%%%%%//////////////////////////(/((((((((((((((     
  &&&&&&&&%%%%%%%%%%%%%%%%%%///////////////////////////(((((((((((((((     
      &&&&&%%%%%%%%%%%%%%%%%/////////////////////////(((((((((((((((((     
         %&&%%%%%%%%%%%%%%%%///////////////////((/((((((((((((((((((((     
             &%%%%%%%%%%%%%%/////////////////((((((((((((((((((            
                 %%%%%%%%%%%///////////////(/(((((((((                     
                    ,%%%%%%%/////////////(/(((                             
                        %%%%/////////                                      
                            /                                              
`,
  `
                                                                           
                                                                           
                                                 &&&&&                     
                         &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&                    
     &&&&&&&&&&&&&&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&&&&&                  
     &&%%%%%%%%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%                 
     &&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%                
     &&&&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%              
     &&&&&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%             
     &&&&&&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%            
     &&&&&&&&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          
     &&&&&&&&&&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%/*////////////          
     &&&&&&&&&&&%%%%%%%%%%%(*******************//////////////////          
     &&&&&&&&&&&&*************************///////////////////////          
     &&&&&&&&&&&&********************////////////////////////////          
     &&&&&&&&&&&&**************//////////////////////////////////          
     &&&&&&&&&&&&*******/////////////////////////////////////////          
     &&&&&&&&&&&&*///////////////////////////////////////////////          
     &&&&&&&&&&&&////////////////////////////////////////////////          
     &&&&&&&&&&&&////////////////////////////////////////////////          
     &&&&&&&&&&&&////////////////////////////////////////////////          
     &&&&&&&&&&&&////////////////////////////////////////////////          
      &&&&&&&&&&&////////////////////////////////////////////////          
       &&&&&&&&&&////////////////////////////////////////////////          
        &&&&&&&&&////////////////////////////////////////////////          
          &&&&&&&////////////////////////////////////////////////          
           &&&&&&////////////////////////////////////////////////          
            &&&&&////////////////////////////////////////////////          
              &&&////////////////////////////////////////////////          
               &&//////////////////////////////                            
                &//////                                                    
                                                                           
`,
  `
                                                                           
                                                                           
                                                                           
             &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&                        
            &&&&&&&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&&&&&&&&&&&            
            %%%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%%%%%&            
           %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&            
          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&            
          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&            
         %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&            
        %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&            
        %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&            
        ***********************************************#%&&&&&&            
        /////*****/**************************************&&&&&&            
        ////////////*************************************&&&&&&            
        ////////////////////*/***************************&&&&&&            
        //////////////////////////////*******************&&&&&&            
        /////////////////////////////////////////////////&&&&&&            
        /////////////////////////////////////////////////&&&&&&            
        /////////////////////////////////////////////////&&&&&&            
        /////////////////////////////////////////////////&&&&&&            
        /////////////////////////////////////////////////&&&&&&            
        /////////////////////////////////////////////////&&&&&             
        /////////////////////////////////////////////////&&&&@             
        /////////////////////////////////////////////////&&&&              
        /////////////////////////////////////////////////&&&               
        /////////////////////////////////////////////////&&&               
        /////////////////////////////////////////////////&&                
        /////////////////////////////////////////////////&                 
                /////////////////////////////////////////&                 
                                                                           
                                                                           
`,
  `
                                                                           
                                                                           
                      &&&&&&&&&&&                                          
                   &&&&&&&&&&&&&&&&&&&&&&&&%%                              
                &&&&&&&&&&&&&&&&&%&&&%&&&&&&&&&&&&&&&&&&                   
             %%%%%%%&%%%%%%%%%%%%%%%%%%%%%%%%&%%%%%%%&%%%%%%%%%%%&&        
           %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&      
        %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&      
     %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&&&&      
  %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&&&&&&      
  //////////%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&&&&&&&      
  /////////////////////%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&&&&&&&&&&&      
  ////////////////////////////////%%%%%%%%%%%%%%%%%%%%%%%&&&&&&&&&&&&      
  /////////////////////////////////////////**/%%%%%%%%%%%&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%%%%%&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%%%%&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%%%%&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%%%&&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%%&&&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%%&&&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%%&&&&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%&&&&&&&&&&&&&&&&&&      
  ////////////////////////////////////////////%%%%%&&&&&&&&&&&&&&&&&&      
  ((//////////////////////////////////////////%%%&&&&&&&&&&&&&&&&&&&&      
  (((/////////////////////////////////////////%%%&&&&&&&&&&&&&&&&&         
  ((((((//////////////////////////////////////%%&&&&&&&&&&&&&&&            
  (((((((((///////////////////////////////////&&&&&&&&&&&&&&               
   /((((((/(((////////////////////////////////&&&&&&&&&&&                  
              (///////////////////////////////&&&&&&&&                     
                         /////////////////////&&&&&&                       
                                    //////////&&&                          
                                                                           
`
];

const bootMessages = [
  "[0.000000] Linux version 5.15.0-cube (cube@cubeos) (gcc version 11.2.0)",
  "[0.012445] Command line: BOOT_IMAGE=/vmlinuz root=/dev/sda1 quiet splash",
  "[0.125891] Kernel command line: BOOT_IMAGE=/vmlinuz root=/dev/sda1",
  "[0.234567] PCI: Using configuration type 1 for base access",
  "[0.456789] Memory: 16384MB available (8192K kernel, 2048K data)",
  "[0.567890] Dentry cache hash table entries: 1048576",
  "[0.678901] Mount-cache hash table entries: 16384",
  "[0.789012] CPU0: Intel(R) Core(TM) i7-10700K CPU @ 3.80GHz",
  "[0.890123] ACPI: Core revision 20210730",
  "[1.012345] NET: Registered protocol family 16",
  "[1.123456] PCI: Probing PCI hardware",
  "[1.234567] USB subsystem initialized",
  "[1.345678] Loading 3D environment drivers...",
  "[1.456789] Graphics subsystem: WebGL 2.0 initialized",
  "[1.567890] Audio subsystem: Web Audio API ready",
  "[1.678901] Input devices: Mouse and keyboard detected",
  "[1.789012] Network: Connection established",
  "[1.890123] CubeOS desktop environment loading...",
  "[2.001234] [  OK  ] All systems operational",
];

const LoadingScreen = ({ onFinish }) => {
  const { progress } = useProgress();
  const [loadingFinished, setLoadingFinished] = useState(false);
  const [frame, setFrame] = useState(0);
  const [showPrompt, setShowPrompt] = useState(false);
  const [terminalOutput, setTerminalOutput] = useState("");
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [showCursor, setShowCursor] = useState(true);
  const [systemReady, setSystemReady] = useState(false);

  // Blinking cursor effect
  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 530);
    
    return () => clearInterval(cursorInterval);
  }, []);

  // Handle boot message typing synced with loading progress
  useEffect(() => {
    if (progress > 0) {
      // Calculate how many messages should be shown based on current progress
      const messagesPerProgress = bootMessages.length / 100;
      const targetMessageCount = Math.floor(progress * messagesPerProgress);
      const currentMessageCount = terminalOutput.split('\n').filter(line => line.startsWith('[')).length;
      
      // If we need to add more messages
      if (currentMessageCount < targetMessageCount && currentMessageCount < bootMessages.length) {
        const nextMessage = bootMessages[currentMessageCount];
        
        // Add message immediately - typing speed matches loading speed
        setTerminalOutput(prev => {
          const newOutput = prev ? prev + '\n' + nextMessage : nextMessage;
          return newOutput;
        });
      }
      
      // When loading is complete and all messages are shown
      if (progress >= 100 && currentMessageCount >= bootMessages.length && !systemReady) {
        setTimeout(() => {
          setSystemReady(true);
          setTerminalOutput(prev => 
            prev + '\n\nCubeOS 5.15.0-cube tty1\n\ncube login: guest\nPassword: \nLast login: ' + 
            new Date().toLocaleString() + '\n\nWelcome to CubeOS!\n\nguest@cubeos:~$ '
          );
        }, 200);
      }
    }
  }, [progress, systemReady, terminalOutput]);

  useEffect(() => {
    if (progress >= 100 && systemReady) {
      setLoadingFinished(true);
      setTimeout(() => setShowPrompt(true), 800);
    }
  }, [progress, systemReady]);

  useEffect(() => {
    const frameInterval = setInterval(() => {
      setFrame((prev) => (prev + 1) % frames.length);
    }, 150); // Slightly faster for more dynamic feel
  
    return () => clearInterval(frameInterval);
  }, []);

  const renderLoadingBar = () => {
    const barLength = 40;
    const filledLength = Math.round((progress / 100) * barLength);
    const emptyLength = barLength - filledLength;
    return `[${'>'.repeat(filledLength)}${'.'.repeat(emptyLength)}] ${Math.round(progress)}%`;
  };

  return (
    <div className="loading-screen">
      {/* Terminal output with blinking cursor - fade out when loading complete */}
      <div className={`terminal-output ${loadingFinished ? 'fade-out' : ''}`}>
        <pre className="boot-message">
          {terminalOutput}
          {!systemReady && showCursor && <span className="cursor">█</span>}
        </pre>
      </div>
      
      {/* CUBEOS Logo - large, top right */}
      {systemReady && (
        <div className="cubeos-logo">
          <pre className="cubeos-text">
            {`
   ____ _   _ ____  _____ ___  ____  
  / ___| | | | __ )| ____/ _ \\/ ___| 
 | |   | | | |  _ \\|  _|| | | \\___ \\ 
 | |___| |_| | |_) | |__| |_| |___) |
  \\____|\\___/|____/|_____\\___/|____/ 
                                     
            `}
          </pre>
        </div>
      )}

      {/* ASCII Spinner - separate container, below CUBEOS */}
      {systemReady && (
        <div className="ascii-spinner-wrapper">
          <pre className="ascii-spinner">{frames[frame]}</pre>
        </div>
      )}

      {/* Loading bar - show based on actual progress */}
      <div style={{
        position: 'absolute',
        bottom: '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center'
      }}>
        {progress > 0 && (
          <pre className="loading-bar">{renderLoadingBar()}</pre>
        )}
        {loadingFinished && showPrompt && (
          <div style={{ marginTop: '20px' }}>
            <button className="start-button retro" onClick={onFinish}>
              start
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;